/* Ourcade theme behaviours: mobile nav, gallery thumbs, hero slider, marquee pause, grid columns, sort, sticky buy bar. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Campaign reference: remember ?oc_ref= from a marketing link (30 days) and carry it into the order
     as a cart attribute (oc_ref) and a hidden line item property (_oc_ref, survives Buy it now). */
  (function () {
    var KEY = 'oc-ref', PARAM = 'oc_ref', MAX_AGE = 30 * 24 * 60 * 60 * 1000;
    var ref = null;
    try {
      var fromUrl = new URLSearchParams(window.location.search).get(PARAM);
      if (fromUrl) fromUrl = fromUrl.trim().slice(0, 200);
      if (fromUrl) {
        ref = fromUrl;
        localStorage.setItem(KEY, JSON.stringify({ v: ref, t: Date.now() }));
      } else {
        var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (saved && saved.v && Date.now() - saved.t < MAX_AGE) ref = saved.v;
        else if (saved) localStorage.removeItem(KEY);
      }
    } catch (e) { /* storage unavailable: fall through with whatever the URL gave us */ }
    if (!ref) return;

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.attributes && cart.attributes[PARAM] === ref) return;
        var attributes = {};
        attributes[PARAM] = ref;
        return fetch(updateUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () { /* non-critical */ });

    var tagForm = function (form) {
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      var input = form.querySelector('input[name="properties[_' + PARAM + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_' + PARAM + ']';
        form.appendChild(input);
      }
      input.value = ref;
    };
    document.querySelectorAll('form[action*="/cart/add"]').forEach(tagForm);
    document.addEventListener('submit', function (e) { tagForm(e.target); }, true);

    /* Red Bank Rumble only: show the visitor's personalised image as the main product image.
       The default stays in place if the custom image fails to load. */
    if (/\/products\/red-bank-rumble\/?$/.test(window.location.pathname)) {
      var main = document.querySelector('[data-oc-gallery] [data-oc-media]:first-child img');
      if (main) {
        var src = 'https://custom.ourcade.com/' + encodeURIComponent(ref) + '.png';
        var probe = new Image();
        probe.onload = function () {
          var swap = function (img) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.width = probe.naturalWidth;
            img.height = probe.naturalHeight;
            img.src = src;
          };
          swap(main);
          var thumb = document.querySelector('[data-oc-gallery] [data-oc-thumb] img');
          if (thumb) swap(thumb);
        };
        probe.src = src;
      }
    }
  })();

  /* Mobile navigation dialog */
  document.querySelectorAll('[data-oc-nav-open]').forEach(function (btn) {
    var dialog = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dialog) return;
    btn.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
    });
    dialog.addEventListener('close', function () {
      btn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      btn.focus();
    });
    dialog.querySelectorAll('[data-oc-nav-close]').forEach(function (c) {
      c.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  });

  /* Product gallery thumbnails */
  document.querySelectorAll('[data-oc-gallery]').forEach(function (gallery) {
    var stage = gallery.querySelector('[data-oc-stage]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-oc-thumb]'));
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-oc-media]'));
    if (!stage || !thumbs.length) return;
    var setCurrent = function (i) {
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (items[i]) {
          stage.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        setCurrent(i);
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) setCurrent(items.indexOf(en.target));
        });
      }, { root: stage, threshold: [0.6] });
      items.forEach(function (it) { io.observe(it); });
    }
  });

  /* Hero slider: scroll-snap track, auto-advance with pause, seamless loop via a cloned first slide */
  document.querySelectorAll('[data-oc-slider]').forEach(function (root) {
    var track = root.querySelector('[data-oc-slider-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var count = slides.length;
    if (count < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-oc-slider-dot]'));
    var toggle = root.querySelector('[data-oc-slider-toggle]');
    var caption = root.querySelector('[data-oc-slider-caption]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var index = 0, timer = null, settle = null, hovering = false, visible = true;
    var userPaused = reduceMotion || root.getAttribute('data-autoplay') === 'false';

    var clone = slides[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.inert = true; // keeps the loop copy's link out of the tab order
    var cloneLink = clone.querySelector('a');
    if (cloneLink) cloneLink.setAttribute('tabindex', '-1');
    var cloneImg = clone.querySelector('img');
    if (cloneImg) { cloneImg.removeAttribute('fetchpriority'); cloneImg.setAttribute('alt', ''); }
    track.appendChild(clone);

    function setActive(i) {
      index = i;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (caption) caption.textContent = slides[i].getAttribute('data-caption') || '';
    }
    function go(i, smooth) {
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (userPaused || hovering || !visible || document.hidden) return;
      timer = setInterval(function () { go(index + 1, true); }, interval);
    }
    function renderToggle() {
      if (!toggle) return;
      toggle.setAttribute('data-state', userPaused ? 'paused' : 'playing');
      toggle.setAttribute('aria-label', toggle.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause'));
      track.setAttribute('aria-live', userPaused ? 'polite' : 'off');
    }

    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i >= count) { track.scrollTo({ left: 0, behavior: 'auto' }); i = 0; }
        setActive(i);
      }, 120);
    }, { passive: true });

    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n, true); play(); }); });
    if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; renderToggle(); play(); });
    root.addEventListener('mouseenter', function () { hovering = true; stop(); });
    root.addEventListener('mouseleave', function () { hovering = false; play(); });
    root.addEventListener('focusin', function () { hovering = true; stop(); });
    root.addEventListener('focusout', function () { hovering = false; play(); });
    document.addEventListener('visibilitychange', play);
    window.addEventListener('resize', function () { go(index, false); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; play(); }, { threshold: 0.25 }).observe(root);
    }
    renderToggle();
    play();
  });

  /* Marquee pause toggle (WCAG 2.2.2); the choice is remembered across pages */
  document.querySelectorAll('[data-oc-marquee-toggle]').forEach(function (btn) {
    var wrap = btn.closest('.oc-marquee-wrap');
    if (!wrap) return;
    var set = function (paused, persist) {
      wrap.classList.toggle('is-paused', paused);
      btn.setAttribute('data-state', paused ? 'paused' : 'playing');
      btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
      if (persist) { try { localStorage.setItem('oc-marquee-paused', paused ? '1' : '0'); } catch (e) { /* storage unavailable */ } }
    };
    var saved = null;
    try { saved = localStorage.getItem('oc-marquee-paused'); } catch (e) { /* storage unavailable */ }
    set(saved === '1', false);
    btn.hidden = false;
    btn.addEventListener('click', function () { set(!wrap.classList.contains('is-paused'), true); });
  });

  /* Collection column toggle */
  document.querySelectorAll('[data-oc-cols]').forEach(function (wrap) {
    var grid = document.getElementById(wrap.getAttribute('data-oc-cols'));
    if (!grid) return;
    var btns = Array.prototype.slice.call(wrap.querySelectorAll('button'));
    var apply = function (n, persist) {
      grid.setAttribute('data-cols', n);
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.value === n ? 'true' : 'false'); });
      if (persist) { try { localStorage.setItem('oc-cols', n); } catch (e) { /* storage unavailable */ } }
    };
    var saved = null;
    try { saved = localStorage.getItem('oc-cols'); } catch (e) { /* storage unavailable */ }
    if (saved === '2' || saved === '3') apply(saved, false);
    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.value, true); }); });
  });

  /* Sort select submits its form */
  document.querySelectorAll('[data-oc-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (!sel.form) return;
      if (sel.form.requestSubmit) sel.form.requestSubmit(); else sel.form.submit();
    });
  });

  /* Line total next to the add-to-cart label */
  function formatMoney(cents, format) {
    var value = (cents / 100);
    var f = format || '${{amount}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = Math.round(value).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': out = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      default: out = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  document.querySelectorAll('[data-oc-line-total]').forEach(function (el) {
    var form = el.closest('form');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    var priceCents = parseInt(el.getAttribute('data-price-cents'), 10);
    var fmt = el.getAttribute('data-money-format');
    if (!qty || isNaN(priceCents)) return;
    var update = function () {
      var q = parseInt(qty.value, 10);
      if (!q || q < 1) q = 1;
      el.textContent = formatMoney(priceCents * q, fmt);
    };
    qty.addEventListener('change', update);
    qty.addEventListener('input', update);
  });

  /* Personaliser gate. The Ourcade widget hides the add-to-cart form (inline display:none) until a game
     preview is approved. We keep the form showing so customers can buy now and personalize after checkout,
     and lock Add to cart only while a preview is under way (anything entered, generating, or awaiting
     approval), so unapproved art is never mistaken for part of the order. form[data-oc-gate-state] is
     open (not started), locked (under way) or ready (approved, or the widget isn't gating).
     This reads the widget's open shadow root. A widget screen it doesn't recognise counts as under way,
     which falls back to the widget's own approve-first behaviour. */
  document.querySelectorAll('[data-oc-gate]').forEach(function (wrap) {
    var form = wrap.querySelector('form[data-type="add-to-cart-form"]');
    var host = document.getElementById(wrap.getAttribute('data-oc-gate'));
    var submit = form && form.querySelector('[type="submit"]');
    if (!host || !submit || submit.disabled || !('MutationObserver' in window)) return;
    var notes = Array.prototype.slice.call(form.querySelectorAll('[data-oc-gate-note]'));
    var reset = form.querySelector('[data-oc-gate-reset]');
    var root = null;
    var watchRoot = new MutationObserver(function () { update(); });

    var onForm = function () { return !!(root && root.querySelector('[data-key="submit"]')); };
    var uploading = function () { return !!(root && root.querySelector('[data-key="photo"][aria-disabled="true"]')); };
    // The untouched form: nothing typed, no photo uploaded or uploading, no option picked.
    var blank = function () {
      if (!onForm() || uploading() || root.querySelector('.preview-img, [aria-pressed="true"]')) return false;
      return Array.prototype.every.call(root.querySelectorAll('input:not([type="file"]), textarea'), function (el) {
        return !el.value.trim();
      });
    };
    var update = function () {
      if (!root && host.shadowRoot) {
        root = host.shadowRoot;
        watchRoot.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-disabled'] });
      }
      var state = form.style.display !== 'none' ? 'ready' : blank() ? 'open' : 'locked';
      if (form.getAttribute('data-oc-gate-state') === state) return;
      form.setAttribute('data-oc-gate-state', state);
      submit.disabled = state === 'locked';
      var payment = form.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = state === 'locked';
      var note = null;
      notes.forEach(function (n) {
        n.hidden = n.getAttribute('data-oc-gate-note') !== state;
        if (!n.hidden) note = n;
      });
      if (note) submit.setAttribute('aria-describedby', note.id);
      else submit.removeAttribute('aria-describedby');
    };

    // Typing doesn't re-render the widget, but its input events cross the shadow boundary.
    host.addEventListener('input', update);
    new MutationObserver(update).observe(host, { childList: true });
    new MutationObserver(update).observe(form, { attributes: true, attributeFilter: ['style'] });
    document.addEventListener('submit', function (e) {
      if (e.target === form && form.getAttribute('data-oc-gate-state') === 'locked') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    if (reset) reset.addEventListener('click', function () {
      if (onForm() && !uploading()) {
        // Still on the form: empty it in place. The widget keeps its own state in step with these events and clicks.
        root.querySelectorAll('input:not([type="file"]), textarea').forEach(function (el) {
          if (!el.value) return;
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
        });
        root.querySelectorAll('[aria-pressed="true"]').forEach(function (b) { b.click(); });
        var photo = root.querySelector('.preview-row [data-key="photo"]');
        if (photo) photo.click();
        update();
        if (!submit.disabled) submit.focus();
        return;
      }
      // Generating or awaiting approval: only a fresh page clears it. Drop the ?ourcade_job resume link first.
      if (!window.confirm(reset.getAttribute('data-confirm') || '')) return;
      var url = new URL(window.location.href);
      if (url.searchParams.has('ourcade_job')) {
        url.searchParams.delete('ourcade_job');
        history.replaceState(history.state, '', url);
      }
      window.location.reload();
    });
    update();
  });

  /* Mobile sticky buy bar: scroll to the personaliser until a preview is approved, then submit the form.
     The form stays on screen under the personaliser gate, so its state decides; otherwise the form's visibility. */
  document.querySelectorAll('[data-oc-sticky-buy]').forEach(function (bar) {
    var form = document.getElementById(bar.getAttribute('data-oc-sticky-buy'));
    var btn = bar.querySelector('button');
    var target = document.getElementById(bar.getAttribute('data-oc-scroll-target') || '');
    if (!form || !btn) return;
    var labelStart = bar.getAttribute('data-label-start') || '';
    var labelReady = bar.getAttribute('data-label-ready') || '';
    var update = function () {
      var gate = form.getAttribute('data-oc-gate-state');
      var waiting = gate ? gate !== 'ready' : form.offsetParent === null || getComputedStyle(form).display === 'none';
      var start = waiting && !!target;
      bar.setAttribute('data-state', start ? 'start' : 'ready');
      btn.textContent = start ? labelStart : labelReady;
      btn.disabled = !start && waiting;
    };
    update();
    if ('MutationObserver' in window) {
      new MutationObserver(update).observe(form, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'data-oc-gate-state'] });
    }
    btn.addEventListener('click', function () {
      if (bar.getAttribute('data-state') === 'ready') {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      } else if (target) {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        var first = target.querySelector('input, button, [tabindex]');
        if (first) first.focus({ preventScroll: true });
      }
    });
  });
})();
